import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Lock, ArrowRight } from 'lucide-react';
export function OfferSection() {
  return <section id="offer-section" className="py-24 relative overflow-hidden" data-id="element-99">
      {/* Background Glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-brand-orange/10 blur-[120px] rounded-t-full pointer-events-none" data-id="element-100" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-101">
        <FadeIn data-id="element-102">
          <div className="text-center mb-12" data-id="element-103">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-104">
              Recupera el control de tu jornada{' '}
              <span className="text-brand-orange" data-id="element-105">hoy mismo.</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-106">
              Olvida la culpa por no haber empezado y conviértete en la persona
              que hace que las cosas sucedan.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-107">
          <div className="bg-brand-card rounded-3xl p-8 md:p-12 border border-brand-orange/30 shadow-glow-lg text-center relative overflow-hidden" data-id="element-108">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-brand-orange to-transparent" data-id="element-109" />

            <p className="text-lg text-gray-400 mb-4 uppercase tracking-wider font-semibold" data-id="element-110">
              Acceso Inmediato al PDF
            </p>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-8" data-id="element-111">
              "10-Minute Anti-Procrastination Rituals"
            </h3>

            <div className="flex flex-col items-center mb-10" data-id="element-112">
              <div className="flex items-center justify-center gap-4" data-id="element-113">
                <span className="text-gray-500 line-through text-2xl font-medium" data-id="element-114">
                  $19.99 USD
                </span>
                <span className="text-6xl font-extrabold text-white" data-id="element-115">
                  $6.39 <span className="text-2xl text-brand-orange" data-id="element-116">USD</span>
                </span>
                <span className="bg-brand-orange text-white text-sm font-bold px-3 py-1 rounded-full uppercase tracking-wide animate-pulse" data-id="element-117">
                  -68%
                </span>
              </div>
              <p className="text-brand-orange font-semibold mt-3 text-lg" data-id="element-118">
                ¡Ahorras $13.60!
              </p>
            </div>

            <Button id="offer-cta" onClick={() => {
            const checkoutUrl = 'https://alldigital.market/cart/48757354856600:1';
            const pixelId = '811020704801198';
            // Fire pixel via fbq if available
            try {
              if (typeof window.fbq === 'function') {
                window.fbq('track', 'AddToCart', {
                  content_name: 'Ritual Anti-Procrastinación de 10 Minutos',
                  content_type: 'product',
                  value: 6.39,
                  currency: 'USD'
                });
              }
            } catch (e) {
              // silently fail
            }
            // Fire pixel via Image beacon as fallback
            try {
              const img = new Image();
              img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=AddToCart&cd[content_name]=Ritual+Anti-Procrastinacion&cd[value]=6.39&cd[currency]=USD&noscript=1`;
            } catch (e) {
              // silently fail
            }
            // Small delay to let pixel fire, then redirect
            setTimeout(() => {
              window.open(checkoutUrl, '_blank', 'noopener,noreferrer');
            }, 300);
          }} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-119">
              DESCARGAR RITUAL AHORA
              <ArrowRight size={24} data-id="element-120" />
            </Button>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-400 mt-6" data-id="element-121">
              <div className="flex items-center gap-2" data-id="element-122">
                <Lock size={16} className="text-green-500" data-id="element-123" />
                <span data-id="element-124">Pago 100% seguro</span>
              </div>
              <span className="hidden sm:block text-gray-600" data-id="element-125">•</span>
              <span data-id="element-126">Acceso instantáneo</span>
              <span className="hidden sm:block text-gray-600" data-id="element-127">•</span>
              <span data-id="element-128">Garantía de 7 días</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}